import { DeleteWithToken, GetWithToken, PostWithToken, PatchWithToken, PutWithToken } from "../../lib/request";

export const createCollection = (data) => {
    return async function () {
        return await PostWithToken("/v2/admin/collection", data);
    };
};

export const getAllCollections = (query) => {
    return async function () {
        const limit = query?.limit || 10;
        const offset = query?.offset || 0;
        const search = query?.search ? `&search=${encodeURIComponent(query.search)}` : "";
        return await GetWithToken(`/v2/admin/collection?limit=${limit}&offset=${offset}${search}`);
    };
};

export const getCollectionById = (id) => {
    return async function () {
        return await GetWithToken(`/v2/admin/collection/${id}`);
    };
};

export const updateCollectionById = (id, data) => {
    return async function () {
        return await PatchWithToken(`/v2/admin/collection/${id}`, data);
    };
};

export const getCollectionProducts = (id) => {
    return async function () {
        return await GetWithToken(`/v2/admin/collection/${id}/products`);
    };
};

export const updateCollectionProducts = (id, productIds) => {
    return async function () {
        return await PutWithToken(`/v2/admin/collection/${id}/products`, {
            product_ids: productIds,
        });
    };
};

export const deleteCollectionById = (id) => {
    return async function () {
        return await DeleteWithToken(`/v2/admin/collection/${id}`);
    };
};
